<template>
  <div class="app-wrapper">
    <!-- 左侧导航 -->
    <TwoColumnSidebar />
    
    <!-- 主内容区 -->
    <div class="main-container">
      <!-- 顶部导航栏 -->
      <div class="navbar">
        <Navbar />
      </div>
      
      <!-- 主要内容 -->
      <AppMain />
      
      <!-- 删除或注释掉这个调试面板 -->
      <!-- <div v-if="showDebugInfo" class="debug-panel">
        <p>当前路径: {{ $route.path }}</p>
        <p>路由名称: {{ $route.name }}</p>
        <p>路由组件: {{ $route.matched[0]?.components?.default?.name || 'Layout' }}</p>
        <p>路由匹配: {{ JSON.stringify($route.matched.map(r => ({ "path": r.path, "name": r.name }))) }}</p>
        <button @click="showDebugInfo = false">关闭调试信息</button>
      </div> -->
    </div>


    <el-alert v-if="!networkStatus" class="nonetalert" title="暂无网络链接" type="error" center :closable="false" />

  </div>
</template>

<script>
import TwoColumnSidebar from '@/components/TwoColumnSidebar/index.vue'
import Navbar from './components/Navbar.vue'
import AppMain from './components/AppMain.vue'
import { onMounted, onUnmounted, ref, watch } from 'vue';
import { ElMessage } from 'element-plus';
import wsClient from '@/utils/websocket';
import { storage, STORAGE_KEYS, convertNetLinkHead } from '@/utils/config';
import eventBus from '@/utils/eventBus'
import { useNetwork } from '@vueuse/core';

export default {
  name: 'Layout',
  components: {
    TwoColumnSidebar,
    Navbar,
    AppMain
  },
  data() {
    return {
      showDebugInfo: false // 确保这个值为 false
    }
  },
  created() {
    console.log('layout created')
  },
  setup() {
    // WebSocket消息处理函数
    const handleWebSocketMessage = (data) => {
      switch (data.event) {
        case 'message':
        case 'user_online_change':
          eventBus.emit('notification_chat', data)
          break;
      
        case 'system_notification':
          // 处理系统通知
          ElMessage({
            type: data.level || 'info',
            message: data.content,
            duration: 5000
          });
          break;
        default:
          console.log('收到未知类型消息:', data);
      }
    };

    // 组件挂载时连接WebSocket
    onMounted(() => {
      // 检查用户是否已登录
      console.log('layout onMounted')

      const userInfo = storage.get(STORAGE_KEYS.USER_INFO);
      if (userInfo) {
        // 添加消息监听器
        wsClient.onMessage(handleWebSocketMessage);
        // 连接WebSocket
        wsClient.connect();
      }else {
        wsClient.close();
      }

      eventBus.on('notification', (data) => {
        if (data.type == 'update_websocketUrl') {
          wsClient.updateUrl(data.wssurl, data.json)
          return
        }
      })
    });

    // 组件卸载时清理WebSocket连接
    onUnmounted(() => {
      eventBus.off('notification')
      wsClient.offMessage(handleWebSocketMessage);
      wsClient.close();
    });

    const { isOnline } = useNetwork(); // 使用useNetwork来获取网络状态信息
    const networkStatus = ref(isOnline.value); // 将状态存储在响应式引用中以便在模板中使用或响应变化
    watch(isOnline, (newStatus) => { // 监听网络状态变化并更新响应式引用值
      networkStatus.value = newStatus;
      console.log('网络状态变化了：', networkStatus.value)
      if (!networkStatus.value) {

        return
      } 
      eventBus.emit('knetwork_status_change', networkStatus.value)
      wsClient.connect();
    }); 

    return {
      networkStatus
    }
  }
}
</script>

<style>
/* 全局样式，确保html和body没有滚动条 */
html, body {
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

#app {
  height: 100%;
}
</style>

<style scoped>
.app-wrapper {
  position: relative;
  height: 100vh;
  width: 100%;
  display: flex;
}

.main-container {
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.navbar {
  height: 50px;
  background-color: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px;
}

.app-main {
  flex: 1;
  overflow: hidden;
}

/* 移除这个样式，可能导致内容区域被隐藏 */
/* .app-main > div {
  height: 100%;
  overflow-y: auto;
  padding: 20px;
  box-sizing: border-box;
} */

/* 移除这个样式，让各页面自己控制内部padding */
/* .app-main .wework-config-container,
.app-main .wework-account-container,
.app-main .wework-department-container,
.app-main .wework-tag-container,
.app-main .wework-message-container {
  padding: 0 !important;
} */

 .nonetalert {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 40%;
  transform: translate(-50%, -50%);
  z-index: 10000;
 }


</style> 